import React, { useEffect, useState } from "react";

import createRegCss from "../../css/createregister.module.css";
import commoncss from "../../css/common.module.css";
import buttoncss from "../../css/button.module.css";
import InputGroup from "../../elements/InputGroup";
import Loader2 from "../../elements/Loader2";
import Dropdown from "../../elements/Dropdown";
import { useHistory, useParams } from "react-router";
import { createLeaseRegisterApiHandler } from "../../../WorkSpace/Components/ApiServices/apiHandler";
import swal from "sweetalert";
import { toast } from "react-toastify";
import ApproverLeaseModal from "../leases/ApproverLeaseModal";

const CreateLeaseRegister = (props) => {
  
  const user = JSON.parse(localStorage.getItem("user"));

  let companyOptions = props.companyOptions;
  const history = useHistory();

  const [loader, setLoader] = useState(false);
  const [regName, setRegName] = useState(null);
  const [company, setCompany] = useState(null);
  const [approverId, setApproverId] = useState(null);
  const [approverLeaseModal, setApproverLeaseModal] = useState(false);

  const createRegister = () => {
    const payload = {
      name: regName,
      companyID: company.value,
    };
    console.log(payload);
    createLeaseRegisterApiHandler(payload)
      .then((response) => {
        console.log(
          "Create Lease Register resp",
          response,
          response?.data?.project?._id
        );
        if (response?.data?.project?._id) {
          setLoader(true);
          window.location.href = `${process.env.REACT_APP_LEASE_FRONTEND_URL}overview/${response?.data?.project?._id}`;
        }
      })
      .catch((error) => {
        swal(
          "Error",
          error?.response?.data?.error || "Unable Create Lease Register",
          "error"
        );
      });
  };
  const sendForApproval = (approverlID) => {
    const payload = {
      name: regName,
      companyID: company.value,
      approvalStatus: "pending approval",
      approverID: approverlID,
    };
    console.log(payload);
    createLeaseRegisterApiHandler(payload)
      .then((response) => {
        console.log("response", response);

        if (response?.data?.project) {
          swal(
            "Success",
            "Approval sent for creation of lease register",
            "success"
          );
          setApproverLeaseModal(false);
          history.push('/dashboard')
        }
      })
      .catch((error) => {
        swal(
          "Error",
          error?.response?.data?.error || "Unable send for approval",
          "error"
        );
      });
  };
  return (
    <>
      {loader && <Loader2 />}
      <div className={createRegCss.alignForm}>
        <div className={createRegCss.container2}>
          <div className={`${commoncss.dFlex} mb-3`}>
            <div
              className={commoncss.dFlexClm}
              style={{ alignItems: "center" }}
            >
              <span className={createRegCss.heading1}>
                Create Lease Register
              </span>
              <span className={createRegCss.label1}>
                Give your register a name and tag it to a company
              </span>
            </div>
          </div>
          <div className={`${createRegCss.container3} mt-3 mb-1`}>
            <InputGroup
              label="Name of Lease Register"
              inputs={[
                <>
                  <input
                    name="invreg_name"
                    placeholder="Placeholder Text"
                    type="text"
                    value={regName}
                    onChange={(e) => setRegName(e.target.value)}
                  />
                </>,
              ]}
            />

            <InputGroup
              label="Company name"
              class_="mt-2"
              inputs={[
                <>
                  {companyOptions.length > 0 && (
                    <Dropdown
                      //   label="Select Company"
                      value={company}
                      options={companyOptions}
                      onSelect={(opt) => setCompany(opt)}
                      placeHolder={"Select Company"}
                      searchable={true}
                    />
                  )}
                </>,
              ]}
            />

            <div className="mt-4" style={{ width: "70%", placeSelf: "center" }}>
              {user?.isAdmin === "Yes" && (
                <button
                  type="submit"
                  className={`${buttoncss.primary} ${
                    !company?.value || !regName ? buttoncss.disabledBtn : ""
                  }`}
                  style={{
                    padding: "7px",
                    width: "100%",
                    "border-radius": "12px",
                  }}
                  onClick={createRegister}
                >
                  Create Lease Register
                </button>
              )}
              {user?.responsibilities === "preparer" && (
                <button
                  type="submit"
                  className={`${buttoncss.primary} ${
                    !company?.value || !regName ? buttoncss.disabledBtn : ""
                  }`}
                  style={{
                    padding: "7px",
                    width: "100%",
                    "border-radius": "12px",
                  }}
                  onClick={() => {
                    company?.value && regName && setApproverLeaseModal(true);
                  }}
                  disabled={!company?.value || !regName}
                >
                  Send for approval
                </button>
              )}
            </div>
            {approverLeaseModal && (
              <ApproverLeaseModal
                setApproverLeaseModal={setApproverLeaseModal}
                companyId={company?.value}
                setApproverId={setApproverId}
                sendForApproval={sendForApproval}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateLeaseRegister;
